const key = {
    USER_ID: `user_jpbvrQOjz6Idg8LNmqLXU`, //userID
    TEMPLATE_ID: `template_0d65pqb`,         //templateID
    SERVICE_ID: `service_pvyom19`
}

export default key